"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "modal-card"
  }, [_c("header", {
    staticClass: "modal-card-head"
  }, [_c("p", {
    staticClass: "modal-card-title"
  }, [_vm._v("Víncular Página ao Grupo")]), _vm._v(" "), _c("button", {
    staticClass: "delete",
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.close
    }
  })]), _vm._v(" "), _c("section", {
    staticClass: "modal-card-body"
  }, [_c("form", {
    attrs: {
      id: "formNewTypeService"
    }
  }, [_c("app-select", {
    attrs: {
      label: "Páginas",
      placeholder: "Selecione o Serviço",
      error: _vm.$v.form.codPage.$error,
      items: _vm.getListPages,
      option: "codPage",
      "name-item": "name"
    },
    on: {
      "update:error": function updateError($event) {
        return _vm.$set(_vm.$v.form.codPage, "$error", $event);
      }
    },
    model: {
      value: _vm.$v.form.codPage.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.codPage, "$model", $$v);
      },
      expression: "$v.form.codPage.$model"
    }
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "btn-content"
  }, [_c("b-button", {
    staticClass: "btn-save",
    attrs: {
      slot: "footer",
      type: "is-info"
    },
    on: {
      click: _vm.checkForm
    },
    slot: "footer"
  }, [_vm._v("\n        Salvar\n      ")])], 1)])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;